import UserRequestListActionTypes from '../actions/user-request-list-action-types';

const initialState = {
  loading: false,
  userRequests: null,
  userRequestsCancelToken: null,
  isConfirmDialogVisible: false,
  selectedCompetencySurveyStudentId: null,
  confirmDialogMessage: '',
  confirmDialogAction: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UserRequestListActionTypes.LOAD_USER_REQUEST_LIST_START:
      return {
        ...state,
        loading: true
      };
    case UserRequestListActionTypes.LOAD_USER_REQUEST_LIST_END:
      return {
        ...state,
        userRequests: action.payload,
        loading: false
      };
    case UserRequestListActionTypes.TOGGLE_CONFIRM_DIALOG:
      return {
        ...state,
        selectedCompetencySurveyStudentId: action.payload?.dataItem?.id,
        confirmDialogMessage: action.payload?.message || '',
        confirmDialogAction: action.payload?.confirmAction || null,
        isConfirmDialogVisible: !state.isConfirmDialogVisible
      };
    default:
      return state;
  }
};
